module.exports = __webpack_public_path__ + "img/headImg.dc700b0a.png";